import {ReactComponent as trade } from './trade.svg'
import {ReactComponent as check } from './check.svg'

export const FaTrade = trade;
export const FaCheck = check;